import React, { useEffect, useState } from "react";
import { db } from "../../utils/firebaseConfig";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

function CommentManager() {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    const loadComments = async () => {
      const snapshot = await getDocs(collection(db, "comments"));
      const commentData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setComments(commentData);
    };

    loadComments();
  }, []);

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "comments", id));
    setComments(prev => prev.filter(c => c.id !== id));
  };

  return (
    <div>
      <h2>Manage Comments</h2>
      {comments.map(c => (
        <div key={c.id} style={{ marginBottom: "1rem", borderBottom: "1px solid #ccc" }}>
          <p><strong>{c.username}</strong>: {c.text}</p>
          <button onClick={() => handleDelete(c.id)}>Delete</button>
        </div>
      ))}
    </div>
  );
}

export default CommentManager;
